<template>
  <div class="wrap">
    <Nav :title="$t('newAdd.BankCardAdd')" fixed safeAreaInsetTop placeholder />
    <div class="content">
      <div class="bank">
        <div class="bank_item">
          <div class="label">{{ $t('fullName') }}:</div>
          <van-field v-model="formData.name" label-width="0" :placeholder="$t('fullNamePlaceholder')" />
        </div>
        <div class="bank_item">
          <div class="label">{{ $t('bank') }}:</div>
          <van-field v-model="formData.bank" label-width="0" :placeholder="$t('bankPlaceholder')" />
        </div>
        <div class="bank_item">
          <div class="label">{{ $t('bankNumber') }}:</div>
          <van-field v-model="formData.card" label-width="0" :placeholder="$t('bankNumber')" />
        </div>
      </div>
      <div @click="confirm" class="button">
        {{ $t("user.Button.Two") }}
      </div>
    </div>
  </div>
</template>



<script>
import { GET_USER_BANK_INFO, COMMIT_USER_BANK_INFO } from "@/api";
import { Toast, Field } from "vant";
import Nav from "@/components/Navbar";
export default {
  components: {
    [Toast.name]: Toast,
    [Field.name]: Field,
    Nav,
  },
  data() {
    return {
      formData: {
        name: '',
        bank: '',
        card: ''
      },
    };
  },
  mounted() {
    this.getUserBankInfo();
  },
  methods: {
    confirm() {
      if (!this.formData.name) return Toast(this.$t('fullNameError'));
      if (!this.formData.bank) return Toast(this.$t('bankError'));
      if (!this.formData.card) return Toast(this.$t('bankNumberError'));
      this.itemClick()
    },
    itemClick() {
      COMMIT_USER_BANK_INFO(this.formData).then(res => {
        Toast(res.msg);
        setTimeout(() => {
          this.$router.go(-1);
        }, 1500);
      }).catch(err => {
        Toast(err.msg);
      });
    },
    getUserBankInfo() {
      GET_USER_BANK_INFO().then(res => {
        if (res.data && res.data.length) {
          this.formData = res.data[0]
        }
      }).catch((e) => {
        console.error(e);
      });
    },
  },
};
</script>

<style scoped lang="less">
.wrap {
  min-height: 100vh;
  background-color: var(--newbg);

  .content {
    padding: calc(20rem / 16) calc(10rem / 16);

    .bank {
      padding: calc(10rem / 16);
      border-radius: calc(10rem / 16);
      color: var(--white);
      background: url(../../assets/new/bankcard-bg.png) no-repeat;
      background-color: #fbb350;
      background-size: contain;
      background-position: bottom;

      .bank_item {
        margin: calc(20rem / 16) 0;

        .label {
          padding-bottom: calc(10rem / 16);
          font-size: calc(14rem / 16);
        }

        /deep/ .van-cell {
          height: calc(45rem / 16);
          line-height: calc(45rem / 16);
          padding: 0 calc(16rem / 16);
          border-radius: calc(5rem / 16);

          .van-field__body {
            input {
              color: #606266;
              font-size: calc(14rem / 16);
            }
          }
        }
      }
    }

    .button {
      border-radius: calc(4rem / 16);
      height: calc(45rem / 16);
      line-height: calc(45rem / 16);
      background-color: #f96;
      font-size: calc(14rem / 16);
      color: var(--white);
      text-align: center;
      margin-top: calc(40rem / 16);
    }
  }
}
</style>